// import React, { useState, useEffect } from "react";
// import "./full-menu.css";
// import SelectedMenuItem from "../SelectedMenuItem/SelectedMenuItem";

// // Sample Menu Categories
// const allCategories = [
//   "All",
//   "iftar_package",
//   "late_night",
//   "dinner",
//   "lunch",
//   "breakfast",
//   "snacks",
//   "drinks",
//   "pre_order",
//   "catering",
// ];

// // Time Periods and Their Ranges
// const timePeriods = {
//   breakfast: { start: "08:00", end: "11:00" },
//   lunch: { start: "11:00", end: "16:00" },
//   // snacks: { start: "16:00", end: "18:00" },
//   dinner: { start: "18:00", end: "20:00" },
//   // late_night: { start: "20:00", end: "06:00" },
// };

// // Time-Restricted Categories
// const timeRestrictedCategories = [
//   "breakfast",
//   "lunch",
//   // "snacks",
//   "dinner",
//   // "late_night",
// ];

// // Utility Function to Get Current Time Period
// const getCurrentTimePeriod = () => {
//   const now = new Date();
//   const currentTime = now.toTimeString().slice(0, 5); // "HH:MM"

//   for (const [period, { start, end }] of Object.entries(timePeriods)) {
//     if (start <= end) {
//       if (currentTime >= start && currentTime <= end) {
//         return period;
//       }
//     } else {
//       // Handle overnight periods (e.g., late_night: 22:00 - 04:00)
//       if (currentTime >= start || currentTime <= end) {
//         return period;
//       }
//     }
//   }
//   return null; // No active period
// };

// const FullMenu = ({ selectedCategory, items }) => {
//   const [activeCategory, setActiveCategory] = useState(selectedCategory);
//   const [selectedItem, setSelectedItem] = useState(null);
//   const [currentTimePeriod, setCurrentTimePeriod] = useState(
//     getCurrentTimePeriod(),
//   );

//   // Update the active category when the selectedCategory prop changes
//   useEffect(() => {
//     setActiveCategory(selectedCategory);
//   }, [selectedCategory]);

//   // Update the current time period every minute
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentTimePeriod(getCurrentTimePeriod());
//     }, 60000); // Update every minute

//     return () => clearInterval(interval); // Cleanup interval on unmount
//   }, []);

//   // Filter menu items based on the active category and current time period
//   const filteredMenu = items.filter((item) => {
//     const matchesCategory =
//       activeCategory === "All" || item.category.includes(activeCategory);

//     // Check if the item's category is time-restricted
//     const isTimeRestricted = item.category.some((cat) =>
//       timeRestrictedCategories.includes(cat),
//     );

//     // If the item is time-restricted, check if it matches the current time period
//     const matchesTimePeriod =
//       !isTimeRestricted ||
//       (currentTimePeriod && item.category.includes(currentTimePeriod));

//     return matchesCategory && matchesTimePeriod && item.availability;
//   });

//   return (
//     <section className="full-menu" id="full-menu">
//       <div className="full-menu-container">
//         <h2 className="full-menu-title">Our Menu</h2>

//         {/* Category Filters */}
//         <div className="menu-filters">
//           {allCategories.map((category) => (
//             <button
//               key={category}
//               className={`filter-btn ${
//                 activeCategory === category ? "active" : ""
//               }`}
//               onClick={() => setActiveCategory(category)}
//             >
//               {category.replace(/_/g, "-").toUpperCase()}
//             </button>
//           ))}
//         </div>

//         {/* Display Current Time Period */}
//         <div className="py-2 px-2 text-white font-bold text-center">
//           {currentTimePeriod
//             ? `CURRENTLY SERVING: ${currentTimePeriod
//                 .replace(/_/g, "-")
//                 .toUpperCase()}`
//             : "Currently serving Drinks, Pre-order & Catering."}
//         </div>

//         {/* Menu Items */}
//         <div className="full-menu-content">
//           {filteredMenu.map((item) => (
//             <div key={item._id} className="menu-item">
//               <img
//                 src={item.imageUrl[0]}
//                 alt={item.title}
//                 className="menu-item-img"
//               />
//               <h3 className="menu-item-title">{item.title}</h3>
//               <p className="menu-item-description">{item.desc}</p>
//               <p className=" font-bold pt-4">
//                 {item.category[0].replace(/_/g, "-").toUpperCase()}
//               </p>
//               <div className="menu-item-price-order">
//                 <span className="menu-item-price">৳{item.price}</span>
//                 <button
//                   className="menu-item-order-btn btn btn-primary"
//                   onClick={() => setSelectedItem(item)}
//                 >
//                   Add to Cart
//                 </button>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Selected Item Modal */}
//       {selectedItem && (
//         <SelectedMenuItem
//           menuItem={selectedItem}
//           closeModal={() => setSelectedItem(null)}
//         />
//       )}
//     </section>
//   );
// };

// export default FullMenu;

import React, { useState, useEffect } from "react";
import "./full-menu.css";
import SelectedMenuItem from "../SelectedMenuItem/SelectedMenuItem";

// Sample Menu Categories
const allCategories = [
  "All",
  "iftar_package",
  "late_night",
  "dinner",
  "lunch",
  "breakfast",
  "snacks",
  "drinks",
  "pre_order",
  "catering",
];

const FullMenu = ({ selectedCategory, items }) => {
  const [activeCategory, setActiveCategory] = useState(selectedCategory);
  const [selectedItem, setSelectedItem] = useState(null);

  // Update the active category when the selectedCategory prop changes
  useEffect(() => {
    setActiveCategory(selectedCategory);
  }, [selectedCategory]);

  // Filter menu items based on the active category only
  const filteredMenu = items.filter((item) => {
    const matchesCategory =
      activeCategory === "All" || item.category.includes(activeCategory);

    return matchesCategory && item.availability;
  });

  return (
    <section className="full-menu" id="full-menu">
      <div className="full-menu-container">
        <h2 className="full-menu-title">Our Menu</h2>

        {/* Category Filters */}
        <div className="menu-filters">
          {allCategories.map((category) => (
            <button
              key={category}
              className={`filter-btn ${
                activeCategory === category ? "active" : ""
              }`}
              onClick={() => setActiveCategory(category)}
            >
              {category.replace(/_/g, "-").toUpperCase()}
            </button>
          ))}
        </div>

        {/* Menu Items */}
        <div className="full-menu-content">
          {filteredMenu.map((item) => (
            <div key={item._id} className="menu-item">
              <img
                src={item.imageUrl[0]}
                alt={item.title}
                className="menu-item-img"
              />
              <h3 className="menu-item-title">{item.title}</h3>
              <p className="menu-item-description">{item.desc}</p>
              <p className=" font-bold pt-4">
                {item.category[0].replace(/_/g, "-").toUpperCase()}
              </p>
              <div className="menu-item-price-order">
                <span className="menu-item-price">৳{item.price}</span>
                <button
                  className="menu-item-order-btn btn btn-primary"
                  onClick={() => setSelectedItem(item)}
                >
                  Add to Cart
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Selected Item Modal */}
      {selectedItem && (
        <SelectedMenuItem
          menuItem={selectedItem}
          closeModal={() => setSelectedItem(null)}
        />
      )}
    </section>
  );
};

export default FullMenu;
